/**
 * Category entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Category extends BaseModel {
    defaults() {
        return {
            id: null,
            category: null,
            for_address: null,
            for_location: null,
            for_event_organizer: null,
            display_order: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            for_address: Boolean,
            for_location: Boolean,
            for_event_organizer: Boolean,
            display_order: Number,
        };
    }

    entityName() {
        return 'Category';
    }
}

export class CategoryCollection extends BaseCollection {
    options() {
        return {
            model: Category,
        };
    }

    entityName() {
        return 'Category';
    }
}
